(function (window) {
    window.__env = window.__env || {};
  
    // API url
    window.__env.GTM_ID = 'GTM-MNJM3LN';
    window.__env.enableDebug = false;
  }(this));